import type { ComponentType, FC } from 'react';
import React, { useCallback, useContext } from 'react';

import {
	IN_EDITOR_TEMPLATES_LOAD_PANEL_CATEGORIES_EXPERIENCE,
	TEMPLATE_GALLERY_CATEGORIES_EXPERIENCE,
} from '@confluence/experience-tracker/entry-points/ExperienceName.ts';
import { ExperienceTrackerContext } from '@confluence/experience-tracker/entry-points/component.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { TransparentErrorBoundary } from '@confluence/error-boundary/entry-points/TransparentErrorBoundary.ts';

export function withErrorBoundary<P extends {}>(
	CategorySelectorComponent: ComponentType<P>,
): FC<P> {
	return (props: P) => {
		const experienceTracker = useContext(ExperienceTrackerContext);
		const failCategoriesExperience = useCallback(
			(error: Error) => {
				experienceTracker.fail({
					name: IN_EDITOR_TEMPLATES_LOAD_PANEL_CATEGORIES_EXPERIENCE,
					error,
				});
				experienceTracker.fail({
					name: TEMPLATE_GALLERY_CATEGORIES_EXPERIENCE,
					error,
				});
			},
			[experienceTracker],
		);

		return (
			<TransparentErrorBoundary
				attribution={Attribution.PAGE_MODES}
				onError={failCategoriesExperience}
			>
				<CategorySelectorComponent {...props} />
			</TransparentErrorBoundary>
		);
	};
}
